import { ExclamationCircleIcon } from "@heroicons/react/16/solid";
import clsx from "clsx";
import { InputHTMLAttributes } from "react";

interface InputProps {
  id: string;
  label?: string;
  error?: string;
  shouldFocus?: boolean;
}

type AllInputProps = InputProps & InputHTMLAttributes<HTMLInputElement>;

export function Input({ label, error, shouldFocus, ...props }: AllInputProps) {
  return (
    <div className={props.className}>
      {label && (
        <label
          className={clsx("block text-sm font-medium leading-6 text-gray-900")}
          htmlFor={props.id}
        >
          {label}
        </label>
      )}
      <div className="relative mt-2 rounded-md shadow-sm">
        <input
          {...props}
          ref={(input) => input && shouldFocus && input.focus()}
          aria-invalid={error ? "true" : "false"}
          aria-describedby={`${props.id}-error`}
          className={clsx(
            "block w-full rounded-md border-0 px-2.5 py-1.5 shadow-sm ring-1 ring-inset focus:ring-2 focus:ring-inset  sm:leading-6",
            error
              ? "text-red-900 ring-red-300 placeholder:text-red-300 focus:ring-red-600"
              : "text-gray-900 ring-gray-300 placeholder:text-gray-400 focus:ring-indigo-600",
          )}
          data-1p-ignore={props.autoComplete === "off" ? "true" : "false"}
        />
        <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
          {error && <ExclamationCircleIcon aria-hidden="true" className="size-5 text-red-500" />}
        </div>
      </div>
      {error && (
        <p id={`${props.id}-error`} className="mt-2 text-sm text-red-600">
          {error}
        </p>
      )}
    </div>
  );
}
